import { makeStyles } from 'tss-react/mui';
import { spacing, colors } from '../../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    contentFeature: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        textAlign: 'center',
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            height: '100%',
        },
    },
    contentInner: {
        width: '100%',
        margin: spacing.large,
        [theme.breakpoints.between('sm', 'lg')]: {
            marginBottom: '56px',
        },
        [theme.breakpoints.up('md')]: {
            margin: spacing.xxl,
            alignSelf: 'center',
        },
        [theme.breakpoints.up('xl')]: {
            margin: '128px',
            alignSelf: 'center',
        },
        '& > :last-child': {
            marginBottom: '0px',
        },
    },
    citationMessage: {
        marginBottom: '20px',
    },
    squareVideoContainer: {
        paddingTop: '100%',
        '& > div': {
            position: 'unset',
        },
        [theme.breakpoints.up('sm')]: {
            paddingTop: '50%',
        },
    },
    quotationMarkStart: {
        transform: 'scaleX(-1)',
        top: '30px',
        left: spacing.large,
        [theme.breakpoints.up('md')]: { top: '61px', left: '73px' },
    },
    quotationMarkEnd: {
        right: '26px',
        bottom: spacing.medium,
        [theme.breakpoints.up('md')]: {
            right: '64px',
            bottom: '69px',
        },
    },
    contentFeatureQuoteContainer: {
        position: 'relative',
        padding: `${spacing.medium} ${spacing.large} !important`, // important to override the default padding
        [theme.breakpoints.up('md')]: {
            padding: `${spacing.large} ${spacing.xl} !important`, // important to override the default padding
        },
        [theme.breakpoints.up('xl')]: {
            padding: `${spacing.xxl} !important`, // important to override the default padding
        },
    },
    // Needed for Content Feature
    contentWithQuotationMarks: {},
    citation: Object.assign(Object.assign({}, theme.typographySpacing.none), { fontStyle: 'italic' }),
    content: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            height: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
        },
    },
    imageSpacer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            width: '50%',
        },
    },
    positionCenter: {
        [theme.breakpoints.up('sm')]: {
            [`& .${classes.imageSpacer}`]: {
                display: 'none',
            },
            [`& .${classes.content}`]: {
                width: '100%',
            },
        },
    },
    textLeft: {
        textAlign: 'left',
    },
    textRight: {
        textAlign: 'right',
    },
    textCenter: {
        textAlign: 'center',
    },
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
            [`& .${classes.image}.${classes.ffImage} img`]: {
                objectPosition: 'bottom right',
            },
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            [`& .${classes.content}`]: {
                justifyContent: 'right',
            },
            [`& .${classes.image}.${classes.ffImage} img`]: {
                objectPosition: 'bottom left',
            },
        },
    },
    image: {},
    ffImage: {},
    readMoreLink: Object.assign(Object.assign({ display: 'inline-flex', justifyContent: 'flex-end', width: '100%' }, theme.typography.xxs_regular), { marginTop: `${spacing.xs} !important`, marginBottom: `${spacing.small} !important`, position: 'relative', color: colors.supplementary.black, zIndex: 4, [theme.breakpoints.down('sm')]: {
            position: 'sticky',
            bottom: 0,
            backgroundColor: 'inherit', // Inherit background to blend with content
            paddingTop: spacing.xs,
        }, '& :last-child': {
            paddingLeft: 0,
            transform: 'rotate(45deg)',
        } }),
    readLessLink: Object.assign(Object.assign({ display: 'flex', justifyContent: 'flex-end', width: '100%' }, theme.typography.xxs_regular), { marginTop: `${spacing.xs} !important`, marginBottom: `${spacing.small} !important`, position: 'relative', color: colors.supplementary.black, zIndex: 4, [theme.breakpoints.down('sm')]: {
            position: 'sticky',
            bottom: 0,
            backgroundColor: 'inherit', // Inherit background to blend with content
            paddingTop: spacing.xs,
        }, '& :last-child': {
            paddingLeft: 0,
            transform: 'rotate(135deg) !important',
        } }),
    contentFeatureInnerContent: {
        padding: `${spacing.medium} ${spacing.medium} 0 ${spacing.medium}!important`,
    },
    mobileContentFeature: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    desktopContentFeature: {
        [theme.breakpoints.up('sm')]: {
            width: '100%',
        },
    },
    showMessageContainer: {
        visibility: 'visible',
        height: 'auto',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            maxHeight: '100%',
            overflow: 'auto', // Allow scrolling when content overflows in mobile expanded state
            flex: '1 1 auto', // Allow flexible growth but within container constraints
        },
    },
    hideMessage: {
        visibility: 'hidden',
        height: 0,
        [theme.breakpoints.down('sm')]: {
            overflow: 'hidden',
        },
    },
}));
export default useStyles;
